export default __webpack_public_path__ + "static/media/rnr-sports-table-25.9f7f62e7.webp";